import {
    madeMirageRegular,
    minion,
    minionIt,
    theinhardtLight,
    theinhardtLightItalic,
    theinhardtMedium,
    theinhardtRegular,
} from '../fonts';
import { ThemeOptions } from '@mui/material';

const generateFontFaces = (): string => {
    return [
        minion,
        minionIt,
        theinhardtLight,
        theinhardtLightItalic,
        theinhardtRegular,
        theinhardtMedium,
        madeMirageRegular,
    ]
        .map((fontFace) => {
            return `@font-face {
          font-family: ${fontFace.fontFamily};
          font-style: ${fontFace.fontStyle};
          font-stretch: ${fontFace.fontStretch};
          font-weight: ${fontFace.fontWeight};
          src: ${fontFace.src};
          }`;
        })
        .join(' ');
};

const body = `strong {
        font-weight: 500 
    }`;

export const MuiCssBaseline = (theme: ThemeOptions) => {
    const styles = theme.components?.MuiCssBaseline;
    if (styles) {
        styles.styleOverrides = generateFontFaces() + ' ' + body;
    }
    return styles;
};
